<style lang="less" scoped>
  .do-appraise-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
    .do-appraise-content {
      max-height: 100%;
      min-height: 90%;
      padding-bottom: 100rpx;
      background: #fff;
      overflow: hidden auto;
    }
    .appraise-merchant {
      display: flex;
      align-items: center;
      height: 104rpx;
      padding: 0 30rpx;
      font-size: 1.2rem;
      font-weight: 500;
      color: #333;
      line-height: 1;
      box-shadow: 0 0 1px 1px #ebebeb;
    }
    .auth-icon {
      height: 1.5em;
      margin-right: 0.6em;
    }
    .merchant-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      line-height: 1.5;
      text-overflow: ellipsis;
    }
    .appraise-score {
      padding: 100rpx 0 60rpx;
      text-align: center;
    }
    .appraise-score-title {
      margin-bottom: 30rpx;
      color: #999;
      line-height: 1;
    }
    .appraise-tag {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 14rpx 0 30rpx;
    }
    .appraise-tag-btn {
      flex: 0 0 auto;
      height: 58rpx;
      padding: 0 24rpx;
      margin-right: 16rpx;
      margin-bottom: 34rpx;
      color: #929292;
      background: #fff;
      border: 1px solid #dadada;
      border-radius: 4rpx;
      outline: none;
      transition: color 0.2s ease, border-color 0.2s ease,
        background-color 0.2s ease;

      &:active,
      &.active {
        color: #ffad0b;
        border-color: #ffad0b;
        background: #ffecc7;
      }
    }
    .appraise-detail {
      padding-top: 3em;
    }
    .appraise-detail-imgs {
      display: flex;
      flex-wrap: wrap;
      padding: 0 30rpx;
    }
    .appraise-detail-img {
      width: 120rpx;
      height: 120rpx;
      margin: 0 16rpx 16rpx 0;
    }
    .appraise-detail-txt {
      padding: 1em 30rpx 0;
      font-size: 0.9rem;
      color: #666;
      line-height: 1.5;
    }
  }
</style>

<template>
  <div class="safe-area-bottom do-appraise-wrapper">
    <div class="do-appraise-content">
      <div class="appraise-merchant">
        <img class="auth-icon"
             src="~@/assets/icon_warranty_order_list_store.png">
        <span class="merchant-name">商家：{{ storeName }}</span>
      </div>
      <div class="appraise-score">
        <div class="appraise-score-title">为服务打分</div>
        <van-rate v-model="evaluateStar"
                  count="5"
                  gutter="8"
                  allow-half
                  readonly
                  :size="36"
                  color="#fea032"
                  void-icon="star" />
      </div>

      <!-- 标签 -->
      <div class="appraise-tag"
           v-if="tagSelected.length">
        <button v-for="(tag, index) in tags"
                :key="index"
                disabled
                :class="{active: tagSelected.includes(tag.id)}"
                class="appraise-tag-btn">{{ tag.preinstallEvaluate }}</button>
      </div>

      <div class="appraise-detail">
        <div v-if="imgPreviewList.length"
             class="appraise-detail-imgs">
          <img class="appraise-detail-img"
               v-for="(item, index) in imgPreviewList"
               :key="index"
               @click="ImagePreviewFn(index)"
               :src="item">
        </div>
        <div v-if="evaluateRemark"
             class="appraise-detail-txt">{{ evaluateRemark }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { queryAppraiseTags, queryOrderWarranty } from '@/config/api.js'

  export default {
    name: 'MyAppraise',
    data () {
      return {
        evaluateStar: 0,
        imgPreviewList: [],
        tags: [],
        tagSelected: [],
        evaluateRemark: '',
        storeName: ''
      }
    },
    methods: {
      ImagePreviewFn (index) {
        const _list = [].concat(this.imgPreviewList)
        this.$imagePreview({
          images: _list,
          startPosition: index,
          closeable: true
        })
      },
      queryAppraiseDtl () {
        queryOrderWarranty({
          keywords: this.$route.query.key,
          tenantId: this.$route.query.usr
        }).then(res => {
          if (res.success) {
            const list = res.result || []
            list.forEach(item => {
              if (item.id === this.$route.query.id) {
                if (item.storeOrderEvaluateBase) {
                  this.evaluateStar = item.storeOrderEvaluateBase.evaluateStar || 0
                  this.evaluateRemark = item.storeOrderEvaluateBase.evaluateRemark || ''

                  const imgs = item.storeOrderEvaluateBase.evaluateImgList || []
                  this.imgPreviewList = imgs.map(item => item.imgPath)

                  const tags = item.storeOrderEvaluateBase.storeOrderEvaluatePreinstallList || []
                  this.tagSelected = tags.map(item => item.id)
                }
              }
            })
          }
        })
      }
    },
    mounted () {
      this.storeName = this.$route.query.store

      this.queryAppraiseDtl()
      queryAppraiseTags().then(res => {
        if (res.success) {
          this.tags = []
          const list = res.result || []
          list.forEach(item => {
            this.tags.push({
              delFlag: item.delFlag,
              id: item.id,
              preinstallEvaluate: item.preinstallEvaluate,
              type: item.type
            })
          })
        }
      })
    }
  }
</script>